var filterCountByType = function filterCountByType() {
  var filtersSelected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filtersSelected.filter(function (filter, i, acc) {
    return acc.findIndex(function (f) {
      return (f == null ? void 0 : f.type) === filter.type;
    }) === i;
  }).length;
};
export default filterCountByType;